import { useState, useEffect } from "react";
import { ConfigProvider } from "antd";
import { getAntDesignDateLocale } from "../i18n/languageService";

const AntdLocaleProvider = ({ children }) => {
  const [currentAntdLocale, setCurrentAntdLocale] = useState(() => getAntDesignDateLocale());

  useEffect(() => {
    const handleLanguageChange = (e) => {
      const newLang = e.detail;
      const locales = getAntDesignDateLocale(newLang);
      setCurrentAntdLocale(locales);
    };

    window.addEventListener("app-language-changed", handleLanguageChange);

    return () => window.removeEventListener("app-language-changed", handleLanguageChange);
  }, []);

  return <ConfigProvider locale={currentAntdLocale}>{children}</ConfigProvider>;
};

export default AntdLocaleProvider;
